import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FLIGHT_ITINERARY_PAGE_PATH } from "@apac/components/flights";
import { postEvaluateKillSwitch } from "@apac/feature-flags";
import { useFintechExercisePage } from "@apac/hooks";
import { DisruptionApp } from "@b2bportal/core-disruption";
import {
  DefaultFlightSlotProvider,
  FlightPostBookingSelectors,
} from "@b2bportal/core-flights";
import { fetchItinerary } from "@b2bportal/core-flights";
import { fetchTripDetails } from "@b2bportal/core-flights";
import { Loading, Page } from "@b2bportal/core-ui";
import { KillSwitchNames, CUSTOMER_SUPPORT_PATH } from "@hsbc/utilities";

export const DisruptionExercisePage = () => {
  const { itinerary, backToItineraryDetailPage, contactCustomerSupport } =
    useFintechExercisePage(
      FlightPostBookingSelectors.getSelectedFlightItinerary,
      FLIGHT_ITINERARY_PAGE_PATH,
      CUSTOMER_SUPPORT_PATH
    );
  const airportMap = useSelector(FlightPostBookingSelectors.getAirports);
  const [disruptionSelfServeRebook, setDisruptionSelfServeRebook] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    postEvaluateKillSwitch(KillSwitchNames.DISRUPTION_SELF_SERVE_REBOOK)
      .then((response) => {
        setDisruptionSelfServeRebook(response.isKillSwitchOn);
      })
      .catch((e) => {
        setDisruptionSelfServeRebook(false);
      });
  }, []);

  if (disruptionSelfServeRebook === null) {
    return <Loading />;
  }

  return (
    <Page>
      <DefaultFlightSlotProvider>
        <DisruptionApp
          disruptedFlight={itinerary}
          onContactSupport={contactCustomerSupport}
          handleExerciseCompleted={backToItineraryDetailPage}
          displayExternalLinkAsModal={true}
          airports={airportMap}
          disruptionSelfServeRebook={disruptionSelfServeRebook}
          fetchItinerary={fetchItinerary}
          fetchTripDetails={fetchTripDetails}
        />
      </DefaultFlightSlotProvider>
    </Page>
  );
};
